/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      type
      id
      mailAddress
      displayName
      lastName
      firstName
      relationship
      birthDate
      gender
      isLiveInJapan
      postalCode
      cancerType
      cancerStage
      diagnosedDate
      diagnosedReason
      hospitalName
      curativeStatus
      cancerHistory
      diagnosedCancerType
      specialty
      affiliation
      businessTitle
      licentiate
      profile
      iconImageKey
      iconUploadedIdentityId
      iconDefaultUrl
      isDeleted
      deletedReason
      deletedAt
      createAt
      updateAt
      counselledCounts
      isCounsellingUnlimitedMode
      paymentCustomerId
      paymentProductId
      paymentSubscriptionId
      paymentSubscriptionStatus
      paymentSubscriptionStartAt
      paymentSubscriptionEndAt
      paymentSubscriptionPaidAt
      consentHamaMEDResearch
      patientIdHamaMEDHospital
      usersApplicableRightsHamaMEDHospital
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        type
        id
        mailAddress
        displayName
        lastName
        firstName
        relationship
        birthDate
        gender
        isLiveInJapan
        postalCode
        cancerType
        cancerStage
        diagnosedDate
        diagnosedReason
        hospitalName
        curativeStatus
        cancerHistory
        diagnosedCancerType
        specialty
        affiliation
        businessTitle
        licentiate
        profile
        iconImageKey
        iconUploadedIdentityId
        iconDefaultUrl
        isDeleted
        deletedReason
        deletedAt
        createAt
        updateAt
        counselledCounts
        isCounsellingUnlimitedMode
        paymentCustomerId
        paymentProductId
        paymentSubscriptionId
        paymentSubscriptionStatus
        paymentSubscriptionStartAt
        paymentSubscriptionEndAt
        paymentSubscriptionPaidAt
        consentHamaMEDResearch
        patientIdHamaMEDHospital
        usersApplicableRightsHamaMEDHospital
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUsersBySpecificUser = /* GraphQL */ `
  query ListUsersBySpecificUser(
    $mailAddress: AWSEmail
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsersBySpecificUser(
      mailAddress: $mailAddress
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        mailAddress
        displayName
        lastName
        firstName
        relationship
        birthDate
        gender
        isLiveInJapan
        postalCode
        cancerType
        cancerStage
        diagnosedDate
        diagnosedReason
        hospitalName
        curativeStatus
        cancerHistory
        diagnosedCancerType
        specialty
        affiliation
        businessTitle
        licentiate
        profile
        iconImageKey
        iconUploadedIdentityId
        iconDefaultUrl
        isDeleted
        deletedReason
        deletedAt
        createAt
        updateAt
        counselledCounts
        isCounsellingUnlimitedMode
        paymentCustomerId
        paymentProductId
        paymentSubscriptionId
        paymentSubscriptionStatus
        paymentSubscriptionStartAt
        paymentSubscriptionEndAt
        paymentSubscriptionPaidAt
        consentHamaMEDResearch
        patientIdHamaMEDHospital
        usersApplicableRightsHamaMEDHospital
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUsersBySpecificType = /* GraphQL */ `
  query ListUsersBySpecificType(
    $type: String
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsersBySpecificType(
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        mailAddress
        displayName
        lastName
        firstName
        relationship
        birthDate
        gender
        isLiveInJapan
        postalCode
        cancerType
        cancerStage
        diagnosedDate
        diagnosedReason
        hospitalName
        curativeStatus
        cancerHistory
        diagnosedCancerType
        specialty
        affiliation
        businessTitle
        licentiate
        profile
        iconImageKey
        iconUploadedIdentityId
        iconDefaultUrl
        isDeleted
        deletedReason
        deletedAt
        createAt
        updateAt
        counselledCounts
        isCounsellingUnlimitedMode
        paymentCustomerId
        paymentProductId
        paymentSubscriptionId
        paymentSubscriptionStatus
        paymentSubscriptionStartAt
        paymentSubscriptionEndAt
        paymentSubscriptionPaidAt
        consentHamaMEDResearch
        patientIdHamaMEDHospital
        usersApplicableRightsHamaMEDHospital
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInformation = /* GraphQL */ `
  query GetInformation($id: ID!) {
    getInformation(id: $id) {
      type
      id
      notificationTargetGroup
      notificationTargetDetail
      notificationText
      notificationUrl
      notificationStartDate
      notificationEndDate
      notificationType
      addUser
      createAt
      updateAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listInformations = /* GraphQL */ `
  query ListInformations(
    $filter: ModelInformationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInformations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        type
        id
        notificationTargetGroup
        notificationTargetDetail
        notificationText
        notificationUrl
        notificationStartDate
        notificationEndDate
        notificationType
        addUser
        createAt
        updateAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listInformationsBySpecificNotificationTargetGroup = /* GraphQL */ `
  query ListInformationsBySpecificNotificationTargetGroup(
    $notificationTargetGroup: String
    $sortDirection: ModelSortDirection
    $filter: ModelInformationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInformationsBySpecificNotificationTargetGroup(
      notificationTargetGroup: $notificationTargetGroup
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        notificationTargetGroup
        notificationTargetDetail
        notificationText
        notificationUrl
        notificationStartDate
        notificationEndDate
        notificationType
        addUser
        createAt
        updateAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAdviserAllowLists = /* GraphQL */ `
  query GetAdviserAllowLists($id: ID!) {
    getAdviserAllowLists(id: $id) {
      type
      id
      mailAddress
      memo
      addUser
      createAt
      isRegistedUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAdviserAllowListss = /* GraphQL */ `
  query ListAdviserAllowListss(
    $filter: ModelAdviserAllowListsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAdviserAllowListss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        mailAddress
        memo
        addUser
        createAt
        isRegistedUser
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAdviserAllowListsBySpecificUser = /* GraphQL */ `
  query ListAdviserAllowListsBySpecificUser(
    $mailAddress: AWSEmail
    $sortDirection: ModelSortDirection
    $filter: ModelAdviserAllowListsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAdviserAllowListsBySpecificUser(
      mailAddress: $mailAddress
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        mailAddress
        memo
        addUser
        createAt
        isRegistedUser
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInvitationAllowLists = /* GraphQL */ `
  query GetInvitationAllowLists($id: ID!) {
    getInvitationAllowLists(id: $id) {
      type
      id
      mailAddress
      memo
      addUser
      createAt
      authenticatedInvitationCode
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listInvitationAllowListss = /* GraphQL */ `
  query ListInvitationAllowListss(
    $filter: ModelInvitationAllowListsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvitationAllowListss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        mailAddress
        memo
        addUser
        createAt
        authenticatedInvitationCode
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listInvitationAllowListsBySpecificUser = /* GraphQL */ `
  query ListInvitationAllowListsBySpecificUser(
    $mailAddress: AWSEmail
    $sortDirection: ModelSortDirection
    $filter: ModelInvitationAllowListsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvitationAllowListsBySpecificUser(
      mailAddress: $mailAddress
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        mailAddress
        memo
        addUser
        createAt
        authenticatedInvitationCode
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStaffAllowLists = /* GraphQL */ `
  query GetStaffAllowLists($id: ID!) {
    getStaffAllowLists(id: $id) {
      type
      id
      mailAddress
      isAdmin
      memo
      addUser
      createAt
      isRegistedUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listStaffAllowListss = /* GraphQL */ `
  query ListStaffAllowListss(
    $filter: ModelStaffAllowListsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaffAllowListss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        mailAddress
        isAdmin
        memo
        addUser
        createAt
        isRegistedUser
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStaffAllowListsBySpecificUser = /* GraphQL */ `
  query ListStaffAllowListsBySpecificUser(
    $mailAddress: AWSEmail
    $sortDirection: ModelSortDirection
    $filter: ModelStaffAllowListsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaffAllowListsBySpecificUser(
      mailAddress: $mailAddress
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        mailAddress
        isAdmin
        memo
        addUser
        createAt
        isRegistedUser
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCounselingTopics = /* GraphQL */ `
  query GetCounselingTopics($id: ID!) {
    getCounselingTopics(id: $id) {
      type
      id
      counselingCategory1
      counselingCategory2
      counselingText
      imageKey1
      imageKey2
      imageKey3
      imageUploadedIdentityId1
      imageUploadedIdentityId2
      imageUploadedIdentityId3
      counselingUserid
      responseEstimatedDate
      lastResponseDate
      status
      responseStatus
      lastResponseReplierType
      lastResponseReplierUserid
      createAt
      updateAt
      relatedLinkUrl1
      relatedLinkUrl2
      relatedLinkUrl3
      relatedLinkUrl4
      relatedLinkUrl5
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCounselingTopicss = /* GraphQL */ `
  query ListCounselingTopicss(
    $filter: ModelCounselingTopicsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCounselingTopicss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        counselingCategory1
        counselingCategory2
        counselingText
        imageKey1
        imageKey2
        imageKey3
        imageUploadedIdentityId1
        imageUploadedIdentityId2
        imageUploadedIdentityId3
        counselingUserid
        responseEstimatedDate
        lastResponseDate
        status
        responseStatus
        lastResponseReplierType
        lastResponseReplierUserid
        createAt
        updateAt
        relatedLinkUrl1
        relatedLinkUrl2
        relatedLinkUrl3
        relatedLinkUrl4
        relatedLinkUrl5
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCounselingTopicsBySpecificCounselingUserid = /* GraphQL */ `
  query ListCounselingTopicsBySpecificCounselingUserid(
    $counselingUserid: String
    $sortDirection: ModelSortDirection
    $filter: ModelCounselingTopicsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCounselingTopicsBySpecificCounselingUserid(
      counselingUserid: $counselingUserid
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        counselingCategory1
        counselingCategory2
        counselingText
        imageKey1
        imageKey2
        imageKey3
        imageUploadedIdentityId1
        imageUploadedIdentityId2
        imageUploadedIdentityId3
        counselingUserid
        responseEstimatedDate
        lastResponseDate
        status
        responseStatus
        lastResponseReplierType
        lastResponseReplierUserid
        createAt
        updateAt
        relatedLinkUrl1
        relatedLinkUrl2
        relatedLinkUrl3
        relatedLinkUrl4
        relatedLinkUrl5
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCounselingTopicsBySpecificStatus = /* GraphQL */ `
  query ListCounselingTopicsBySpecificStatus(
    $status: String
    $sortDirection: ModelSortDirection
    $filter: ModelCounselingTopicsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCounselingTopicsBySpecificStatus(
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        counselingCategory1
        counselingCategory2
        counselingText
        imageKey1
        imageKey2
        imageKey3
        imageUploadedIdentityId1
        imageUploadedIdentityId2
        imageUploadedIdentityId3
        counselingUserid
        responseEstimatedDate
        lastResponseDate
        status
        responseStatus
        lastResponseReplierType
        lastResponseReplierUserid
        createAt
        updateAt
        relatedLinkUrl1
        relatedLinkUrl2
        relatedLinkUrl3
        relatedLinkUrl4
        relatedLinkUrl5
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCounselingTopicsByResponseStatus = /* GraphQL */ `
  query ListCounselingTopicsByResponseStatus(
    $responseStatus: String
    $sortDirection: ModelSortDirection
    $filter: ModelCounselingTopicsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCounselingTopicsByResponseStatus(
      responseStatus: $responseStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        counselingCategory1
        counselingCategory2
        counselingText
        imageKey1
        imageKey2
        imageKey3
        imageUploadedIdentityId1
        imageUploadedIdentityId2
        imageUploadedIdentityId3
        counselingUserid
        responseEstimatedDate
        lastResponseDate
        status
        responseStatus
        lastResponseReplierType
        lastResponseReplierUserid
        createAt
        updateAt
        relatedLinkUrl1
        relatedLinkUrl2
        relatedLinkUrl3
        relatedLinkUrl4
        relatedLinkUrl5
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCounselingReplies = /* GraphQL */ `
  query GetCounselingReplies($id: ID!) {
    getCounselingReplies(id: $id) {
      type
      id
      counselingTopicsId
      replierType
      replierUserid
      replyText
      imageKey1
      imageKey2
      imageKey3
      imageUploadedIdentityId1
      imageUploadedIdentityId2
      imageUploadedIdentityId3
      createAt
      updateAt
      relatedLinkUrl1
      relatedLinkUrl2
      relatedLinkUrl3
      relatedLinkUrl4
      relatedLinkUrl5
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCounselingRepliess = /* GraphQL */ `
  query ListCounselingRepliess(
    $filter: ModelCounselingRepliesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCounselingRepliess(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        counselingTopicsId
        replierType
        replierUserid
        replyText
        imageKey1
        imageKey2
        imageKey3
        imageUploadedIdentityId1
        imageUploadedIdentityId2
        imageUploadedIdentityId3
        createAt
        updateAt
        relatedLinkUrl1
        relatedLinkUrl2
        relatedLinkUrl3
        relatedLinkUrl4
        relatedLinkUrl5
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCounselingRepliesBySpecificReplierUserid = /* GraphQL */ `
  query ListCounselingRepliesBySpecificReplierUserid(
    $replierUserid: String
    $sortDirection: ModelSortDirection
    $filter: ModelCounselingRepliesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCounselingRepliesBySpecificReplierUserid(
      replierUserid: $replierUserid
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        counselingTopicsId
        replierType
        replierUserid
        replyText
        imageKey1
        imageKey2
        imageKey3
        imageUploadedIdentityId1
        imageUploadedIdentityId2
        imageUploadedIdentityId3
        createAt
        updateAt
        relatedLinkUrl1
        relatedLinkUrl2
        relatedLinkUrl3
        relatedLinkUrl4
        relatedLinkUrl5
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCounselingRepliesBySpecificCounselingTopicsId = /* GraphQL */ `
  query ListCounselingRepliesBySpecificCounselingTopicsId(
    $counselingTopicsId: String
    $sortDirection: ModelSortDirection
    $filter: ModelCounselingRepliesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCounselingRepliesBySpecificCounselingTopicsId(
      counselingTopicsId: $counselingTopicsId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        counselingTopicsId
        replierType
        replierUserid
        replyText
        imageKey1
        imageKey2
        imageKey3
        imageUploadedIdentityId1
        imageUploadedIdentityId2
        imageUploadedIdentityId3
        createAt
        updateAt
        relatedLinkUrl1
        relatedLinkUrl2
        relatedLinkUrl3
        relatedLinkUrl4
        relatedLinkUrl5
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMailNotification = /* GraphQL */ `
  query GetMailNotification($id: ID!) {
    getMailNotification(id: $id) {
      type
      id
      targetUserid
      mailAddress
      subject
      message
      addUser
      createAt
      isNeededBackupBcc
      isNeededAsanaForward
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMailNotifications = /* GraphQL */ `
  query ListMailNotifications(
    $filter: ModelMailNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMailNotifications(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        targetUserid
        mailAddress
        subject
        message
        addUser
        createAt
        isNeededBackupBcc
        isNeededAsanaForward
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listMailNotificationTargetUserid = /* GraphQL */ `
  query ListMailNotificationTargetUserid(
    $targetUserid: String
    $sortDirection: ModelSortDirection
    $filter: ModelMailNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMailNotificationTargetUserid(
      targetUserid: $targetUserid
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        targetUserid
        mailAddress
        subject
        message
        addUser
        createAt
        isNeededBackupBcc
        isNeededAsanaForward
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getErrorLog = /* GraphQL */ `
  query GetErrorLog($id: ID!) {
    getErrorLog(id: $id) {
      type
      id
      page
      url
      userid
      userType
      counselingTopicsId
      errorType
      errorNumber
      errorMessage
      addUser
      createAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listErrorLogs = /* GraphQL */ `
  query ListErrorLogs(
    $filter: ModelErrorLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listErrorLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        type
        id
        page
        url
        userid
        userType
        counselingTopicsId
        errorType
        errorNumber
        errorMessage
        addUser
        createAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listErrorLogUserid = /* GraphQL */ `
  query ListErrorLogUserid(
    $userid: String
    $sortDirection: ModelSortDirection
    $filter: ModelErrorLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listErrorLogUserid(
      userid: $userid
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        page
        url
        userid
        userType
        counselingTopicsId
        errorType
        errorNumber
        errorMessage
        addUser
        createAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTimeline = /* GraphQL */ `
  query GetTimeline($id: ID!) {
    getTimeline(id: $id) {
      type
      id
      userid
      userType
      timelineContents
      addUser
      createAt
      updateAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTimelines = /* GraphQL */ `
  query ListTimelines(
    $filter: ModelTimelineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimelines(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        type
        id
        userid
        userType
        timelineContents
        addUser
        createAt
        updateAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTimelinesBySpecificUser = /* GraphQL */ `
  query ListTimelinesBySpecificUser(
    $userid: String
    $sortDirection: ModelSortDirection
    $filter: ModelTimelineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimelinesBySpecificUser(
      userid: $userid
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        userid
        userType
        timelineContents
        addUser
        createAt
        updateAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
